import { Injectable, Output, EventEmitter } from "@angular/core";

/*
  Generated class for the ImageProcessorProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ImageProcessorProvider {
    @Output() resultEvent = new EventEmitter();
    worker: Worker = null;
    currentPending = 0;

    constructor() {
        this.create();
    }

    processImage(image, width, height) {
        this.worker.postMessage({
            image: image,
            width: width,
            height: height
        });
        return this.currentPending++;
    }

    abort() {
        this.worker.terminate();
        this.create();
    }

    private create() {
        let rootUrl = document.URL.split('#')[0];
        this.worker = new Worker(rootUrl + "assets/js/image-worker.js");

        this.worker.onmessage = message => {
            this.currentPending--;
            this.resultEvent.emit({
                status: 1,
                data: message.data
            });
        };

        this.worker.onerror = event => {
            this.currentPending--;
            this.resultEvent.emit({
                status: 0
            });
        };
    }
}
